import { doDelete, doGet, doPost, doPut } from "../../../api/baseAPI";
import { GROLOG_BASE_URL, GROLOG_URL } from "../../../constant/apiConstant";
import { setTableLoading } from '../../../store/reducer/page.reducer'
import { checkValidationToken } from "../../../util/errorHandler";

export const initiateUser = async (token, refresh_token, dispatch) => {
    const url = `${GROLOG_URL}/user/initiate`;
    let result = { data: undefined, ok: false }

    try {
        const response = await doGet(token, url, null);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    return result
}

export const getListUser = async (token, refresh_token, param, dispatch) => {
    const url = `${GROLOG_URL}/user?${param}`;
    let result = { data: undefined, ok: false }

    dispatch(setTableLoading(true))
    try {
        const response = await doGet(token, url, null);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    dispatch(setTableLoading(false))
    return result
}

export const getSearchRecommendation = async (token, refresh_token, keyword, dispatch) => {
    const url = `${GROLOG_URL}/user/search?page=1&limit=10&filter=full_name||username lk ${keyword}`;
    let result = { data: undefined, ok: false }

    try {
        const response = await doGet(token, url, null);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    return result
}

export const getSearchResult = async (token, refresh_token, keyword, dispatch) => {
    const url = `${GROLOG_URL}/user?page=1&limit=10&filter=full_name||username lk ${keyword}`;
    let result = { data: undefined, ok: false }

    dispatch(setTableLoading(true))
    try {
        const response = await doGet(token, url, null);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    dispatch(setTableLoading(false))
    return result
}

export const getDetailUser = async (token, refresh_token, id, dispatch) => {
    const url = `${GROLOG_URL}/user/${id}`;
    let result = { data: undefined, ok: false }

    try {
        const response = await doGet(token, url, null);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    return result
}

export const getCountry = async (token, refresh_token, data, dispatch) => {
    const url = `${GROLOG_URL}/country`;
    let result = { data: undefined, ok: false }

    try {
        const response = await doPost(url, token, data)
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    return result
}

export const getProvince = async (token, refresh_token, data, dispatch) => {
    const url = `${GROLOG_URL}/province`;
    let result = { data: undefined, ok: false }

    try {
        const response = await doPost(url, token, data)
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    return result
}

export const getDistrict = async (token, refresh_token, data, dispatch) => {
    const url = `${GROLOG_URL}/district`;
    let result = { data: undefined, ok: false }

    try {
        const response = await doPost(url, token, data)
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    return result
}

export const getSubDistrict = async (token, refresh_token, data, dispatch) => {
    const url = `${GROLOG_URL}/sub_district`;
    let result = { data: undefined, ok: false }

    try {
        const response = await doPost(url, token, data)
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    return result
}

export const getUrbanVillage = async (token, refresh_token, data, dispatch) => {
    const url = `${GROLOG_URL}/urban_village`;
    let result = { data: undefined, ok: false }

    try {
        const response = await doPost(url, token, data)
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    return result
}

export const initiateCountry = async (token, refresh_token, dispatch) => {
    const url = `${GROLOG_URL}/country/initiate`;
    let result = { data: undefined, ok: false }

    try {
        const response = await doGet(token, url, null);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    return result
}

export const initiateProvince = async (token, refresh_token, dispatch) => {
    const url = `${GROLOG_URL}/province/initiate`;
    let result = { data: undefined, ok: false }

    try {
        const response = await doGet(token, url, null);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    return result
}

export const initiateDistrict = async (token, refresh_token, dispatch) => {
    const url = `${GROLOG_URL}/district/initiate`;
    let result = { data: undefined, ok: false }

    try {
        const response = await doGet(token, url, null);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    return result
}

export const initiateSubDistrict = async (token, refresh_token, dispatch) => {
    const url = `${GROLOG_URL}/sub_district/initiate`;
    let result = { data: undefined, ok: false }

    try {
        const response = await doGet(token, url, null);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    return result
}

export const initiateUrbanVillage = async (token, refresh_token, dispatch) => {
    const url = `${GROLOG_URL}/urban_village/initiate`;
    let result = { data: undefined, ok: false }

    try {
        const response = await doGet(token, url, null);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    return result
}

export const getManagementHistoryList = async (token, refresh_token, dispatch, id) => {
    const url = `${GROLOG_BASE_URL}/audit/v1/grolog/audit?page=1&filter=table_name eq user, primary_key eq ${id}`;
    let result = { data: undefined, ok: false }

    try {
        const response = await doGet(token, url, null);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    return result
}

export const detailUser = async (token, refresh_token, id, dispatch) => {
    const url = `${GROLOG_URL}/user/${id}`;
    let result = { data: undefined, ok: false }

    dispatch(setTableLoading(true))
    try {
        const response = await doGet(token, url, null);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    dispatch(setTableLoading(false))
    return result
}

export const listRole = async (token, refresh_token, page, limit, order, dispatch) => {
    let result = { list: undefined, ok: false }
    const url = `${GROLOG_URL}/role/search`;
    const params = { page, limit, order }

    dispatch(setTableLoading(true));
    try {
        const response = await doGet(token, url, params)

        if (response) {
            result.ok = true
            result.list = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }

    dispatch(setTableLoading(false))
    return result
}

export const listDataGroup = async (token, refresh_token, page, limit, dispatch) => {
    let result = { list: undefined, ok: false }
    const url = `${GROLOG_URL}/data-group/search`;
    const params = { page, limit }

    dispatch(setTableLoading(true));
    try {
        const response = await doGet(token, url, params)

        if (response) {
            result.ok = true
            result.list = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }

    dispatch(setTableLoading(false))
    return result
}

export const listCountry = async (token, refresh_token, page, limit, dispatch) => {
    let result = { list: undefined, ok: false }
    const url = `${GROLOG_URL}/country`;
    const params = { page, limit }

    dispatch(setTableLoading(true));
    try {
        const response = await doGet(token, url, params)

        if (response) {
            result.ok = true
            result.list = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }

    dispatch(setTableLoading(false))
    return result
}

export const listProvince = async (token, refresh_token, page, limit, filter, dispatch) => {
    let result = { list: undefined, ok: false }
    const url = `${GROLOG_URL}/province`;
    const params = { page, limit, filter }

    dispatch(setTableLoading(true));
    try {
        const response = await doGet(token, url, params)

        if (response) {
            result.ok = true
            result.list = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }

    dispatch(setTableLoading(false))
    return result
}

export const listDistrict = async (token, refresh_token, page, limit, filter, dispatch) => {
    let result = { list: undefined, ok: false }
    const url = `${GROLOG_URL}/district`;
    const params = { page, limit, filter }

    dispatch(setTableLoading(true));
    try {
        const response = await doGet(token, url, params)

        if (response) {
            result.ok = true
            result.list = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }

    dispatch(setTableLoading(false))
    return result
}

export const listSubDistrict = async (token, refresh_token, page, limit, filter, dispatch) => {
    let result = { list: undefined, ok: false }
    const url = `${GROLOG_URL}/sub_district`;
    const params = { page, limit, filter }

    dispatch(setTableLoading(true));
    try {
        const response = await doGet(token, url, params)

        if (response) {
            result.ok = true
            result.list = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }

    dispatch(setTableLoading(false))
    return result
}

export const listUrbanVillage = async (token, refresh_token, page, limit, filter, dispatch) => {
    let result = { list: undefined, ok: false }
    const url = `${GROLOG_URL}/urban_village`;
    const params = { page, limit, filter }

    dispatch(setTableLoading(true));
    try {
        const response = await doGet(token, url, params)

        if (response) {
            result.ok = true
            result.list = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }

    dispatch(setTableLoading(false))
    return result
}

export const listPostalCode = async (token, refresh_token, page, limit, filter, dispatch) => {
    let result = { list: undefined, ok: false };
    let order = `id asc`
    const url = `${GROLOG_URL}/postal_code`;
    const params = { page, limit, filter, order }

    dispatch(setTableLoading(true));
    try {
        const response = await doGet(token, url, params)

        if (response) {
            result.ok = true
            result.list = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }

    dispatch(setTableLoading(false))
    return result
}

export const updateUser = async (token, data, id, dispatch) => {
    const url = `${GROLOG_URL}/user/${id}`;
    let result = { message: undefined, success: false }

    dispatch(setTableLoading(true))
    try {
        const response = await doPut(url, token, data);
        if (response?.data?.success) {
            result.success = true;
            result.message = response?.data?.payload?.status?.message
        }
    } catch (error) {
        const errorCode = error?.response?.status;
        const errorMessage = error?.response?.data?.payload?.message;

        if (errorCode === 400) {
            result.success = false;
            result.message = errorMessage;
        }
        checkValidationToken(error, token, null, dispatch)
    }
    dispatch(setTableLoading(false))
    return result
}

export const deleteUser = async (token, refresh_token, id, updated_at, dispatch) => {
    const url = `${GROLOG_URL}/user/${id}`
    let result = { data: undefined, ok: false }

    let data = {
        'updated_at': updated_at
    }

    try {
        const response = await doDelete(url, token, data)
        if (response) {
            result.ok = true
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        const errorCode = error?.response?.status;
        const errorMessage = error?.response?.data?.payload?.message;

        if (errorCode === 400) {
            result.success = false;
            result.message = errorMessage;
        }
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    return result
}